// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { cyber as _cyber } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the cyber chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 7560
 * Chain Name: Cyber
 * Default Block Explorer: https://cyberscan.co
 * Default RPC URL: https://cyber.alt.technology
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { cyber } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: cyber,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const cyber = createCommon({
	..._cyber,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
